import { Trash2 } from 'lucide-preact'
import { text } from '#contract'
import { useClient } from '../app/client-context.ts'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './bin-slot.module.css'
import { useScreenUi } from './screen-context.ts'
import { pressSlot } from './slot-press.ts'

/** The bin under the player's panel: a stack put in it is destroyed. */
export function BinSlot() {
  const t = useT()
  const client = useClient()
  const ui = useScreenUi()
  const holding = useView((view) => (view.inventory?.screen?.cursor ?? null) !== null)
  const gamepad = useView((view) => view.input.device === 'gamepad')
  const label = t(text('inventory.bin'))
  return (
    <button
      type="button"
      class={styles.bin}
      data-target="bin"
      data-holding={holding || undefined}
      aria-label={label}
      onPointerDown={(event) => {
        if (client) pressSlot(event, 'bin', client.inventory, ui)
      }}
      // A gamepad's held stack sits on whatever is focused.
      onFocus={(event) => {
        if (gamepad) ui.setHover({ target: 'bin', element: event.currentTarget })
      }}
      onBlur={(event) => {
        ui.leave(event.currentTarget)
      }}
    >
      <Trash2 class={styles.icon} aria-hidden="true" />
      <span class={styles.label}>{label}</span>
    </button>
  )
}
